import React from "react"

const HowItWorks = ({ className }) => {
  return (
    <section className={className}>
      <div className="inner">
        <h2 className="text-sm-center">
          <em>Collecter</em> plus,
          <br />
          <em className="variant">Collecter</em> mieux,
          <br />
          <em>Distribuer</em> juste&nbsp;!
        </h2>
        <p>
          Tout ça en 3 clics, c'est excitant, non ?<br />
          La mission de WeRECY est de valoriser la matière d’un objet existant
          pour en créer un nouveau. Invendable ou non réparable, nos objets qui
          encombrent notre garage ou nos placards sont souvent destinés à
          l'incinération ou à l'enfouissement. Nous vous proposons de leur
          donner une seconde vie, de les réincarner en nouvelle matière
          valorisable pour la production d'un nouvel objet.
        </p>
      </div>
    </section>
  )
}

export default HowItWorks
